<template>
  <b-modal id="notFound"
           ref="notFoundModal"
           size="lg"
           :hide-header="true"
           :no-close-on-backdrop="true">
    <b-row>
      <b-col lg="8" offset-lg="2" class="pl-5 pr-5">
        <p class="mb-3 lead"> No Report found with the given report ID. Please try again by entering ID below: </p>
        <b-form-input @keyup.enter="retryID" v-model="reportID" type="text" placeholder="Enter your report ID" autofocus="true"/>
        <b-alert class="mt-3" variant="danger" v-model="showRetryError">
          {{ retryErrorMsg }}
        </b-alert>
      </b-col>
    </b-row>

    <div slot="modal-footer" class="w-100">
      <b-button size="lg" variant="primary" @click.prevent="retryID">Retry Report ID</b-button>
    </div>
  </b-modal>
</template>

<script>
import bus from '../../plugins/bus'
export default {
  name: 'NotFoundModal',
  data () {
    return {
      reportID: '',
      showRetryError: false,
      retryErrorMsg: 'The report token is required',
    }
  },
  created () {
    bus.on('notFound', () => {
      document.body.classList.add('blurred')
      this.$refs.notFoundModal.show()
    })
  },
  methods: {
    retryID () {
      if (this.reportID === '') {
        this.showRetryError = true
      } else {
        this.showRetryError = false
        location.href = '/view/' + this.reportID
        // this.$router.push('/view/' + this.reportID)
        this.$refs.notFoundModal.hide()
        document.body.classList.remove('blurred')
      }
    },
  },
  beforeDestroy () {
    bus.off('notFound')
  },
}
</script>

<style>
  #notFound {
  font-family: "averta", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
    text-align: center;
  }
  #notFound .modal-dialog {
    max-width: 50%!important;
  }
  @media screen and (max-width: 575px){
    #notFound .modal-dialog {
      max-width: 95%!important;
      margin: 10% auto 0 auto;
    }
  }
  #notFound button {
    margin: 0 auto;
  }
  #notFound .modal-body::before {
    content: ' ';
    display: block;
    background-image: url(../../assets/img/new-homesearch-fav.png);
    background-repeat: no-repeat;
    background-size: 100px 100px;
    background-position: center 20px;
    width: 100%;
    height: 140px;
  }
  #notFound .lead {
    font-size: 1.25rem;
    font-weight: 300;
  }
</style>
